import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
export function MetaPixel() {
  useEffect(() => {
    initMetaPixel('1491710519002513');
  }, []);
  return <noscript data-id="element-78">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1491710519002513&ev=PageView&noscript=1" alt="" data-id="element-79" />
    </noscript>;
}